import {Props as ReportsSpreadsheetColumnProps} from 'modules/reports/components/Spreadsheet/Column'
import {useReportsSpreadsheetContext} from 'modules/reports/components/Spreadsheet/ReportsSpreadsheet.context'
import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
import useStyles from './ReportsSpreadsheetHeader.styles'

type Props = {
  column: ReportsSpreadsheetColumnProps
}

function ReportsSpreadsheetHeader(props: Props) {
  const {column} = props
  const {prefix, onSort} = useReportsSpreadsheetContext()
  const classes = useStyles()
  const p = usePrefix(`${prefix}-header-${column.name}`)

  return (
    <th className={classes.root} data-testid={p()} onClick={() => onSort(column.name)}>
      {column.name}
    </th>
  )
}

export default ReportsSpreadsheetHeader
